import { httpClientVendasCoreBff } from 'vendas-core/shared/services'

import { useMutationRequest } from '~/ui/hooks/utils'

export interface RetryWebhookEventParams {
  paymentProfileId: string | undefined
  webhookEventId: string
}

async function retryWebhookEvent({ paymentProfileId, webhookEventId }: RetryWebhookEventParams) {
  return httpClientVendasCoreBff<void>({
    url: `/v1/payment-profile/${paymentProfileId}/webhooks/${webhookEventId}/retry`,
    method: 'POST'
  })
}

export function usePostRetrySendEvents() {
  return useMutationRequest(['usePostRetrySendEvents'], retryWebhookEvent)
}
